import {
  Document,
  PDFViewer,
  Page as PDFPage,
  StyleSheet,
  Text as PDFText,
  View as PDFView,
  Image as PDFImage,
  Font
} from '@react-pdf/renderer';
import { dateFormatter, getMonthYear } from '../../../../../utils';

Font.register({
  family: 'Roboto',
  fonts: [{ src: '/Roboto-Bold.ttf', fontWeight: 'bold' }]
});

const styles = StyleSheet.create({
  page: {
    padding: 20
  },
  heading: {
    fontSize: 18,
    textAlign: 'center',
    marginBottom: 20
  },
  line: {
    height: 0.6,
    backgroundColor: 'black',
    marginVertical: 10,
    marginTop: '40px'
  },
  line2: {
    height: 0.4,
    backgroundColor: 'black',
    marginVertical: 10
  },
  contentContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 0,
    marginBottom: 0,
    border: '1px Solid black',
    padding: '10px',
    borderRadius: '5px'
  },
  contentContainer2: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 10,
    marginBottom: 0
  },
  column: {
    flex: 1,
    paddingHorizontal: 10
  },
  row: {
    flexDirection: 'row'
  },
  row2: {
    flexDirection: 'row',
    marginBottom: 5
  },
  text: {
    fontSize: 9,
    display: 'inline-block'
  },
  textBold: {
    fontSize: 9,
    fontWeight: 'bold',
    fontFamily: 'Roboto'
  },
  textUnderlined: {
    textDecoration: 'underline'
  },
  table: {
    display: 'table',
    width: 'auto',
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#bfbfbf',
    marginTop: 5
  },
  tableRow: {
    flexDirection: 'row'
  },
  tableColHeader: {
    width: '14.28%',
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#bfbfbf',
    backgroundColor: '#f0f0f0',
    padding: 5
  },
  tableCol: {
    width: '13.28%',
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#bfbfbf',
    padding: 5
  },
  tableCellHeader: {
    fontSize: 10,
    fontWeight: 'bold'
  },
  columnHeader: {
    width: '15%',
    backgroundColor: 'navy',
    color: 'white',
    padding: 5,
    textAlign: 'center',
    marginTop: '2%'
  },
  tableCell: {
    fontSize: 10
  },
  columnContent: {
    width: '15%',
    padding: 6,
    textAlign: 'center',
    alignItems: 'center'
  }
});

const COLORS = ['#f0f0f0', '#e0e0e0'];

const Page = ({ style, children, ...props }) => (
  <PDFPage style={{ ...styles.page, ...style }} {...props}>
    {children}
  </PDFPage>
);

const View = ({ style, children, ...props }) => (
  <PDFView style={{ ...style }} {...props}>
    {children}
  </PDFView>
);

const Text = ({ style, content, ...props }) => (
  <PDFText style={{ ...styles.text, ...style }} {...props}>
    {content}
  </PDFText>
);

const ITEMS_PER_PAGE = 10;

export const RetailSalePosPDF = ({ data }) => {
  const subTotal = data.productDetails.reduce((acc, cv) => {
    const amount = Number(cv.amount) || 0;
    const discAmt = Number(cv.disc_amt) || 0;
    return acc + amount + discAmt;
  }, 0);

  const totalDiscount = data.productDetails.reduce((acc, cv) => {
    const discAmt = Number(cv.disc_amt) || 0;
    return acc + discAmt;
  }, 0);

  const pages = [];
  for (let i = 0; i < data.productDetails.length; i += ITEMS_PER_PAGE) {
    const chunk = data.productDetails.slice(i, i + ITEMS_PER_PAGE);

    pages.push(
      <Page size="A4" style={styles.page} key={i}>
        {/* <PDFImage
          src="/logo_Hospital_m.jpeg"
          style={{ width: '100%', height: '80px', marginBottom: 1, marginRight: '10%' }}
        /> */}
        <View>
          <Text style={{ fontSize: '20px', margin: '0 auto', fontFamily: 'Roboto' }} content="RR MEDICOSE" />
          <Text
            style={{ fontSize: '10px', margin: '0 auto', fontFamily: 'Roboto', marginTop: '1%' }}
            content="INSIDE RR HEALTHCARE MULTI-SPECIALITY HOSPITAL,ISRANA"
          />
          <Text
            style={{ fontSize: '10px', margin: '0 auto', fontFamily: 'Roboto', marginTop: '1%' }}
            content="DL. No. - RLF20HR2025002198,RLF21HR2025002198"
          />
          <Text
            style={{ fontSize: '10px', margin: '0 auto', fontFamily: 'Roboto', marginTop: '1%' }}
            content="GST - 06AFFPE6176B2ZS"
          />
        </View>

        <View style={{ ...styles.row, marginTop: '2%' }}>
          <Text style={{ fontSize: '12px', margin: '0 auto', fontFamily: 'Roboto' }} content="GST INVOICE" />
        </View>

        {/* Patient & Invoice Details */}
        <View style={styles.contentContainer}>
          <View style={styles.column}>
            <View style={styles.row2}>
              <Text style={styles.textBold} content="Invoice No.    :  " />
              <Text content={`${data.inv_no}`} />
            </View>
            <View style={styles.row2}>
              <Text style={styles.textBold} content="UHID NO.       :  " />
              <Text content={`${data.uhid}`} />
            </View>
            <View style={styles.row2}>
              <Text style={styles.textBold} content="Date/Time     : " />
              <Text content={`${dateFormatter(data.dateTime)}`} />
            </View>
            <View style={styles.row2}>
              <Text style={styles.textBold} content="Address        :  " />
              <Text content={`${data.address}`} />
            </View>
          </View>

          <View style={styles.column}>
            <View style={styles.row2}>
              <Text style={styles.textBold} content="Patient Name   :  " />
              <Text content={`${data.patientName}`} />
            </View>
            <View style={styles.row2}>
              <Text style={styles.textBold} content="Age/Sex            :  " />
              <Text content={`${data.age} / ${data.gender}`} />
            </View>
            <View style={styles.row2}>
              <Text style={styles.textBold} content="Mobile               :  " />
              <Text content={`${data.mobile}`} />
            </View>
          </View>

          <View style={styles.column}>
            <View style={styles.row2}>
              <Text style={styles.textBold} content="Department    :  " />
              <Text content={`${data.department}`} />
            </View>
            <View style={styles.row2}>
              <Text style={styles.textBold} content="Sponsor          :  " />
              <Text content={`${data.sponsor}`} />
            </View>
            <View style={styles.row2}>
              <Text style={styles.textBold} content="Operating Doctor   :  " />
              <Text content={`${data.doctor}`} />
            </View>
          </View>
        </View>

        {/* Table Headers */}
        <View style={styles.row}>
          <Text style={{ ...styles.columnHeader, width: '10%' }} content="Sr." />
          <Text style={{ ...styles.columnHeader, width: '30%' }} content="Product" />
          <Text style={{ ...styles.columnHeader, width: '10%' }} content="Pack" />
          <Text style={{ ...styles.columnHeader, width: '15%' }} content="HSN" />
          <Text style={{ ...styles.columnHeader, width: '20%' }} content="Batch" />
          <Text style={{ ...styles.columnHeader, width: '20%' }} content="Exp." />
          <Text style={{ ...styles.columnHeader, width: '10%' }} content="Qty" />
          <Text style={{ ...styles.columnHeader, width: '10%' }} content="Mrp" />
          <Text style={{ ...styles.columnHeader, width: '15%' }} content="Disc Amt" />
          <Text style={{ ...styles.columnHeader, width: '10%' }} content="Amount" />
        </View>

        {/* Product Rows */}
        {chunk.map((service, index) => (
          <View key={index} style={{ ...styles.row, backgroundColor: COLORS[index % COLORS.length] }}>
            <Text style={{ ...styles.columnContent, width: '10%' }} content={index + 1} />
            <Text style={{ ...styles.columnContent, width: '30%' }} content={service.product_name} />
            <Text style={{ ...styles.columnContent, width: '10%' }} content={service.packing} />
            <Text style={{ ...styles.columnContent, width: '15%' }} content={service.hsn_code} />
            <Text style={{ ...styles.columnContent, width: '20%' }} content={service.batch_no} />
            <Text style={{ ...styles.columnContent, width: '20%' }} content={getMonthYear(service.exp_date)} />
            <Text style={{ ...styles.columnContent, width: '10%' }} content={service.bill_qty} />
            <Text style={{ ...styles.columnContent, width: '10%' }} content={Number(service.mrp).toFixed(2)} />
            <Text style={{ ...styles.columnContent, width: '15%' }} content={Number(service.disc_amt).toFixed(2) } />
            <Text style={{ ...styles.columnContent, width: '10%' }} content={Number(service.amount).toFixed(2)} />
          </View>
        ))}

        {/* Summary Section on Last Page */}
        {i + ITEMS_PER_PAGE >= data.productDetails.length && (
          <View style={{ padding: 16, backgroundColor: '#f9f9f9', borderTopWidth: 1, borderColor: '#ccc' }}>
            <View style={{ flexDirection: 'row', width: '100%' }}>
              {/* Tax Details Section */}
              <View style={{ flex: 1, paddingRight: 8 }}>
                <View
                  style={{
                    flexDirection: 'row',
                    paddingVertical: 6,
                    backgroundColor: '#e0e0e0',
                    borderRadius: 0,
                    width: '100%'
                  }}
                >
                  <Text style={{ fontWeight: 'bold', width: '40%' }} content="Taxable Amount" />
                  <Text style={{ fontWeight: 'bold', width: '20%' }} content="SGST" />
                  <Text style={{ fontWeight: 'bold', width: '20%' }} content="CGST" />
                  <Text style={{ fontWeight: 'bold', width: '20%' }} content="Total GST" />
                </View>

                {data.taxDetails &&
                  data.taxDetails.map((item, idx) => (
                    <View
                      key={idx}
                      style={{
                        flexDirection: 'row',
                        paddingVertical: 6,
                        backgroundColor: COLORS[idx % COLORS.length],
                        borderRadius: 0,
                        marginTop: 4
                      }}
                    >
                      <Text style={{ width: '40%' }} content={Number(item.taxable_amount).toFixed(2)} />
                      <Text style={{ width: '20%' }} content={Number(item.sgst).toFixed(2)} />
                      <Text style={{ width: '20%' }} content={Number(item.cgst).toFixed(2)} />
                      <Text style={{ width: '20%' }} content={Number(item.gst).toFixed(2)} />
                    </View>
                  ))}
              </View>

              {/* Summary Section */}
              <View style={{ flex: 1, paddingLeft: 8 }}>
                <View style={{ flexDirection: 'row', marginBottom: 6 }}>
                  <Text style={{ fontWeight: 'bold', width: 130 }} content="Sub Total :" />
                  <Text style={{ width: 100 }} content={`${Number(subTotal).toFixed(2)}`} />
                </View>

                <View style={{ flexDirection: 'row', marginBottom: 6 }}>
                  <Text style={{ fontWeight: 'bold', width: 130 }} content="Discount :" />
                  <Text style={{ width: 100 }} content={`${Number(totalDiscount).toFixed(2)}`} />
                </View>

                <View style={{ flexDirection: 'row', marginBottom: 6 }}>
                  <Text style={{ fontWeight: 'bold', width: 130 }} content="Bill Amount :" />
                  <Text style={{ width: 100 }} content={`${Number(data.bill_amount).toFixed(2)}`} />
                </View>

                <View style={{ flexDirection: 'row', marginBottom: 6 }}>
                  <Text
                    style={{ fontWeight: 'bold', width: 130, marginRight: -30 }}
                    content={
                      data.pay_mode === 'CASH' || data.pay_mode === 'Both'
                        ? 'Recd :'
                        : data.pay_mode === 'Credit'
                          ? 'Recd :'
                          : ''
                    }
                  />

                  <Text
                    style={{ width: 150 }}
                    content={
                      data.pay_mode === 'CASH'
                        ? `Cash : ${data.rec_amt_1}`
                        : data.pay_mode === 'Both'
                          ? `Cash : ${data.rec_amt_1}   Bank : ${data.rec_amt_2}`
                          : data.pay_mode === 'Credit'
                            ? '0'
                            : ''
                    }
                  />
                </View>
                <View style={{ flexDirection: 'row', marginTop: 4 }}>
                  <Text style={{ fontWeight: 'bold', width: 130 }} content="Balance :" />
                  <Text style={{ width: 100 }} content={`${Number(data.balance_amt).toFixed(2)}`} />
                </View>
              </View>
            </View>
          </View>
        )}
      </Page>
    );
  }

  return (
    <PDFViewer width="100%" height="100%" showToolbar>
      <Document title="Retail Sale Pos">{pages}</Document>
    </PDFViewer>
  );
};
